import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getAllExpedientes.php';

export default function getAllExpedientes(){
    return $.ajax({
        url: URL_API,
        type: 'GET'
    })
}